import { BotonExportarExcel, Card, DesktopOnly, Group, Table, Tbody, Th, Thead, Tr } from "@/components/ui";
import type { Area, OrganizacionAdmin, UsuarioAdmin } from "@/lib/types";
import { UsuarioRow } from "./UsuarioRow";

export function UsuariosDesktopTable({
  usuarios,
  todasAreas,
  todasOrganizaciones,
  editandoId,
  onToggleEditar,
  obtenerFilas,
}: {
  usuarios: UsuarioAdmin[];
  todasAreas: Area[];
  todasOrganizaciones: OrganizacionAdmin[];
  editandoId: string | null;
  onToggleEditar: (id: string) => void;
  /** Trae TODAS las páginas con los filtros actuales · para el export. */
  obtenerFilas: () => Promise<UsuarioAdmin[]>;
}) {
  return (
    <DesktopOnly>
      <Card padding="lg">
        <Group justify="flex-end" className="mb-2">
          <BotonExportarExcel
            archivo="usuarios"
            hoja="Usuarios"
            obtenerFilas={obtenerFilas}
            columnas={[
              { header: "Email", value: (u) => u.email },
              { header: "Nombre", value: (u) => u.fullName },
              { header: "Roles", value: (u) => u.roles.join(", ") },
              { header: "Áreas", value: (u) => u.areas.join(", ") },
              { header: "Organizaciones", value: (u) => u.organizaciones.map((o) => o.nombre).join(", ") },
              { header: "Estado", value: (u) => (u.activo ? "Activo" : "Inactivo") },
            ]}
          />
        </Group>
        <div className="overflow-x-auto">
          <Table verticalSpacing="sm">
            <Thead>
              <Tr>
                <Th>Email</Th>
                <Th>Nombre</Th>
                <Th>Roles</Th>
                <Th>Áreas</Th>
                <Th>Organizaciones</Th>
                <Th>Estado</Th>
                <Th />
              </Tr>
            </Thead>
            <Tbody>
              {usuarios.map((u) => (
                <UsuarioRow
                  key={u.id}
                  u={u}
                  expandida={editandoId === u.id}
                  onToggle={() => onToggleEditar(u.id)}
                  todasAreas={todasAreas}
                  todasOrganizaciones={todasOrganizaciones}
                />
              ))}
            </Tbody>
          </Table>
        </div>
      </Card>
    </DesktopOnly>
  );
}
